// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9df478cf","239":"b3fa67df","455":"9b7a0b0b"}[chunkId] + ".chunk.js";
};